import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { createBrowserHistory } from "history";
import { toastr } from "react-redux-toastr";
import {
  CouponAmountComponent,
  CouponAplicableItemComponent,
  CouponCashbackComponent,
  CouponVMComponent,
} from "./component";
import LoadingSpinner from "../../Loading/component";
import { useNavigate } from "react-router-dom";
import {
  onChange_CouponDescription_Step2,
  onChange_CouponImage_Step3,
  onChange_CouponDate_Step4,
  onChange_CouponDeeplink_Step5,
  onChange_CouponDiscountAmount_Step6,
  onChange_CouponCashbackAmount_Step7,
  onChange_CouponCashbackAmountType_Step10,
  onChange_CouponVendingMachines_Step11,
  onChange_CouponAplicableItem_Step12,
} from "../CouponCreate/action";

const CouponAplicableItemContainer = (props) => {
  const [activeBtn, setActiveBtn] = useState();
  const [activeMvIdBtn, setActiveMvIdBtn] = useState();
  const [showMvIdInput, setShowMvIdInput] = useState(false);
  const [activeSlotIdBtn, setActiveSlotIdBtn] = useState();
  const [showSlotIdInput, setShowSlotIdInput] = useState(false);
  const [activeMealIdBtn, setActiveMealIdBtn] = useState();
  const [showMealIdInput, setShowMealIdInput] = useState(false);

  const [newMvId, setNewMvId] = useState("");
  const [newSlotId, setNewSlotId] = useState("");
  const [newMealTypeIds, setNewMealTypeIds] = useState("");

  const [slotIds, setSlotIds] = useState([]);
  const [mvIds, setMvIds] = useState([]);
  const [mealTypeIds, setMealTypeIds] = useState([]);

  const [slotError, setSlotError] = useState("");
const [mvError, setMvError] = useState("");
const [mealError, setMealError] = useState("");

const handleAddSlot = () => {
  const trimmed = newSlotId.trim();
  if (!trimmed) return;

  if (slotIds.includes(trimmed)) {
    setSlotError("Slot ID already added");
  } else {
    setSlotIds([...slotIds, trimmed]);
    setNewSlotId("");
    setSlotError("");
  }
};

const handleAddMvId = () => {
  const trimmed = newMvId.trim();
  if (!trimmed) return;

  if (mvIds.includes(trimmed)) {
    setMvError("MV ID already added");
  } else {
    setMvIds([...mvIds, trimmed]);
    setNewMvId("");
    setMvError("");
  }
};

const handleAddMeal = () => {
  const trimmed = newMealTypeIds.trim();
  if (!trimmed) return;

  if (mealTypeIds.includes(trimmed)) {
    setMealError("Meal Type ID already added");
  } else {
    setMealTypeIds([...mealTypeIds, trimmed]);
    setNewMealTypeIds("");
    setMealError("");
  }
};


  const navigate = useNavigate();





  const handleChangeSlotIds = (e) => setNewSlotId(e.target.value);
  const handleChangeMealTypesIds = (e) => setNewMealTypeIds(e.target.value);
  const handleChangeMvIds = (e) => setNewMvId(e.target.value);

  const handleMvIdBtnClick = (val) => {
    setActiveMvIdBtn(val);
    setShowMvIdInput(val === "Yes");
  };
  const handleSlotIdBtnClick = (val) => {
    setActiveSlotIdBtn(val);
    setShowSlotIdInput(val === "Yes");
  };
  const handleMealIdBtnClick = (val) => {
    setActiveMealIdBtn(val);
    setShowMealIdInput(val === "Yes");
  };

  const couponCreationStep12 = () => {
    props.getDataFromAPI(
      `/partner/api/v1/coupon/create/draft`,
      "POST",
      {
        step: 12,
        draftId: props.props?.coupon.step1_draftId,
        mvReliability: {
          isMv: activeMvIdBtn === "Yes",
          mvIds,
        },
        slotIdReliability: {
          isSlotId: activeSlotIdBtn === "Yes",
          slotIds,
        },
        mealTypeReliability: {
          isMealType: activeMealIdBtn === "Yes",
          mealTypeIds,
        },
      },
      (response) => {
        props.onChange_CouponDescription_Step2(response);
        props.onChange_CouponImage_Step3(response);
        props.onChange_CouponDate_Step4(response);
        props.onChange_CouponDeeplink_Step5(response);
        props.onChange_CouponDiscountAmount_Step6(response);
        props.onChange_CouponCashbackAmount_Step7(response);
        props.onChange_CouponCashbackAmountType_Step10(response);
        props.onChange_CouponVendingMachines_Step11(response);
        props.onChange_CouponAplicableItem_Step12(response);
        navigate("/home/couponpg");
      },
      (err) => {
        toastr.error("Error", "Failed to create coupon.");
      },
      true
    );
  };

  const handleRemove = (type, index) => {
    if (type === "slot") {
      setSlotIds(slotIds.filter((_, i) => i !== index));
    } else if (type === "mv") {
      setMvIds(mvIds.filter((_, i) => i !== index));
    } else if (type === "meal") {
      setMealTypeIds(mealTypeIds.filter((_, i) => i !== index));
    }
  };

  return (
<CouponAplicableItemComponent
  couponCreationStep12={couponCreationStep12}
  activeBtn={activeBtn}
  newMealTypeIds={newMealTypeIds}
  newMvId={newMvId}
  newSlotId={newSlotId}
  mvIds={mvIds}
  slotIds={slotIds}
  mealTypeIds={mealTypeIds}
  handleChangeMvIds={handleChangeMvIds}
  handleChangeSlotIds={handleChangeSlotIds}
  handleChangeMealTypesIds={handleChangeMealTypesIds}
  handleAddMeal={handleAddMeal}
  handleAddMvId={handleAddMvId}
  handleAddSlot={handleAddSlot}
  handleMvIdBtnClick={handleMvIdBtnClick}
  activeMvIdBtn={activeMvIdBtn}
  showMvIdInput={showMvIdInput}
  handleMealIdBtnClick={handleMealIdBtnClick}
  activeMealIdBtn={activeMealIdBtn}
  showMealIdInput={showMealIdInput}
  handleSlotIdBtnClick={handleSlotIdBtnClick}
  activeSlotIdBtn={activeSlotIdBtn}
  showSlotIdInput={showSlotIdInput}
  slotError={slotError}
  mvError={mvError}
  mealError={mealError}
  handleRemove={handleRemove}
/>

  );
};

const mapStateToProps = (state) => ({ props: state });

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_CouponDescription_Step2,
  onChange_CouponImage_Step3,
  onChange_CouponDate_Step4,
  onChange_CouponDeeplink_Step5,
  onChange_CouponDiscountAmount_Step6,
  onChange_CouponCashbackAmount_Step7,
  onChange_CouponCashbackAmountType_Step10,
  onChange_CouponVendingMachines_Step11,
  onChange_CouponAplicableItem_Step12,
})(CouponAplicableItemContainer);